module.exports = __webpack_public_path__ + "media/images/icons/handshake-c48a102655d41b9d8df8b37f6919e1bd.svg";